<script setup lang="ts">
import type { NuxtLinkProps } from "#app"
import { DropdownMenuItem } from "reka-ui"

defineOptions({ inheritAttrs: false })
defineProps<{ to?: NuxtLinkProps["to"] }>()
defineEmits(["select"])
</script>
<template>
  <DropdownMenuItem
    class="flex w-full cursor-pointer items-center justify-start text-sm font-medium whitespace-nowrap text-zinc-700 transition duration-300 select-none hover:bg-zinc-50 hover:text-zinc-800 has-disabled:cursor-default has-disabled:text-zinc-400 has-disabled:hover:bg-transparent has-disabled:hover:text-zinc-400"
    @select="$emit('select')"
  >
    <NuxtLink
      v-if="to"
      class="flex w-full cursor-pointer items-center gap-2 py-2 pr-6 pl-2 *:data-[slot=icon]:size-4 *:data-[slot=icon]:shrink-0"
      :to
      v-bind="$attrs"
    >
      <slot />
    </NuxtLink>
    <button
      v-else
      class="flex w-full cursor-pointer items-center gap-2 py-2 pr-6 pl-2 disabled:cursor-default *:data-[slot=icon]:size-4 *:data-[slot=icon]:shrink-0"
      v-bind="$attrs"
    >
      <slot />
    </button>
  </DropdownMenuItem>
</template>
